// 功能按钮 // 参数：
<template>
  <div style="display: flex; align-items: flex-end">
    <div class="FuncBtns" v-if="BtnArray.length > 0">
      <div
        class="FuncBtnItem"
        v-for="item in BtnArray"
        :key="item.ID"
        circle
        @click="
          handleClick({ WebName: item.WebName, ButtonName: item.ButtonName })
        "
      >
        <div style="width:45px">
          {{ item.ButtonName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    BtnArray: {
      type: Array,
      default: () => [
        {
          ID: "04021FD0-6823-45FD-90F7-3243BC0057E2",
          MenuID: "CD50D1C6-CEA4-493A-8277-8E2048D30688",
          ButtonName: "导入",
          WebName: "Import",
          ButtonType: "4",
          Action: "",
          Sort: 590,
          IsDisable: false,
          IsDelete: false
        }
      ]
    },
    Duration: "",
    Total: []
  },
  data() {
    return { totalCount: [0, 0] };
  },
  methods: {
    handleClick(val) {
      this.$emit("open", val);
    }
  },
  activated() {
    // this.$bus.on("setTotal", data => {
    //   this.totalCount = data;
    // });
  },
  mounted() {
    // console.log("in");
    // this.$bus.on("setTotal", data => {
    //   console.log(data);
    //   this.totalCount = data;
    // });
  }
};
</script>

<style lang="scss" scoped>
.FuncBtns {
  z-index: 2;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 3px 11px 1px rgba(0, 0, 0, 0.12);
  border-radius: 0px 0px 20px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 125px;
  right: 31px;
  padding: 14px;

  .FuncBtnItem {
    font-size: 12px;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    margin: 0 5px;
    background: #5691f2;
    color: #ffffff;
    border-color: #1890ff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap !important;
    text-align: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FuncBtn/index.vue